export default __webpack_public_path__ + "static/media/spreadsheet.775acf65.svg";